import { Reveal } from "@/components/common/Reveal";
import { EnquiryForm } from "@/components/EnquiryForm";

export const EnquirySection = ({ title = "Ready to get curious?", headingLevel = "h2" }) => {
  const H = headingLevel;
  return (
    <section id="enquire" className="scroll-mt-24 section-y" aria-labelledby="enquire-title" data-testid="enquiry-section">
      <div className="container-x">
        <div className="relative grid gap-10 overflow-hidden rounded-[40px] border border-ink/10 bg-lavender p-7 sm:p-12 lg:grid-cols-[0.8fr_1.2fr] lg:p-16">
          <Reveal>
            <p className="eyebrow">Enquire &amp; enrol</p>
            <H id="enquire-title" className="mt-5 text-4xl sm:text-5xl font-semibold leading-[1.05] tracking-tight">{title}</H>
            <p className="mt-5 text-lg leading-relaxed text-ink">
              Tell us a little about your learner and what sparks their curiosity. We'll reply by email to talk through courses,
              learning options and enrolment.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="rounded-card bg-white p-6 sm:p-8 shadow-soft">
            <EnquiryForm />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
